import { ToggleSwitch } from '@/components/ToggleSwitch';
import React, { ComponentProps } from 'react';
import { FieldWrapper } from './FieldWrapper';

type ToggleFieldProps = {
  label?: React.ReactNode;
  className?: string;
  labelPosition?: ComponentProps<typeof FieldWrapper>['labelPosition'];
} & Omit<ComponentProps<typeof ToggleSwitch>, 'labels'>;

export const ToggleField = ({
  label,
  labelPosition = 'left',
  checked = false,
  onToggle,
  disabled = false,
  size = 'sm',
  className,
}: ToggleFieldProps) => {
  return (
    <FieldWrapper
      label={label}
      className={className}
      labelPosition={labelPosition}
    >
      <ToggleSwitch
        checked={checked}
        onToggle={onToggle}
        disabled={disabled}
        size={size}
      />
    </FieldWrapper>
  );
};
